module.exports = __webpack_public_path__ + "img/UTOTTE-3.feeafe66.jpg";